export default "__VITE_ASSET__HK7HWE$C__"